jQuery( function($) {

    $(document).find('[data-hidden]').each( function() {

        var element = $(this);

        if ( element.data('hidden') ) {
            element.css( 'visibility', 'hidden' );
        }
    });
});

jQuery(window).on( 'load', function() {

    jQuery(document).find('[data-animate]').each( function() {

        var element = jQuery(this);
        var classes = 'animated ' + element.data('animate');
        var delay   = element.data('delay');

        if ( ! delay ) {
            delay = 1;
        }

        if ( element.data('infinite') ) {
            classes += ' infinite';
        }

        element.on( 'inview', function( event, inview ) {

            if ( inview ) {

                setTimeout( function() {
                    element.css( 'visibility', 'visible' ).addClass( classes );
                }, delay );

                element.off( 'inview' );
            }
        });
    });
});